import { useContext } from 'react';
import { GlobalContext } from '../../context/GlobalState';

function useImFacilitator() {
  const { user, retrospective } = useContext(GlobalContext);
  return user?.id === retrospective?.facilitator;
}

export default useImFacilitator;
